import { SingleNews } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Markdown } from '~/components/markdown/Markdown';

import { ArticleDate } from '../article-date/ArticleDate';
import { AssetChip } from '../asset-chip/AssetChip';
import * as S from './SingleArticle.styles';

export interface SingleArticleProps {
  article?: SingleNews;
  isLoading: boolean;
  onEntityClick(entityTag: string): void;
}

export const SingleArticle = ({
  article,
  isLoading,
  onEntityClick,
}: SingleArticleProps) => {
  const { t } = useTranslation('news');

  return (
    <S.SingleArticleRoot data-testid="single-article">
      <S.Title>{article?.title}</S.Title>
      {!!article && (
        <S.Meta>
          <S.MetaItem>
            <ArticleDate date={article.published} />
          </S.MetaItem>
          <S.MetaItem>
            {
              /* i18next-extract-mark-context-next-line ["benzinga", "mtn", "dowjones"] */
              t('news:source', {
                context: article.source,
              })
            }
          </S.MetaItem>
        </S.Meta>
      )}

      {article && (
        <S.AssetChips>
          {article.entities.map(entityTag => (
            <AssetChip
              key={entityTag}
              entityTag={entityTag}
              onEntityClick={onEntityClick}
            />
          ))}
        </S.AssetChips>
      )}

      {isLoading && <S.ContentSkeleton data-testid="loading-state" />}

      {!isLoading && article?.body && <Markdown message={article.body} />}
    </S.SingleArticleRoot>
  );
};
